/** Query telemetry rows using one or more filter criteria. */
export const telemetryQuerySpec = {
    uri: '/telemetry/query',
    method: 'POST',
    adminOnly: true,
};
